module.exports = __webpack_public_path__ + "media/images/flags/4x3/esh-799b45ba4041a1e36e5c91bdc37190e6.svg";